import { Easing } from 'react-native'

export const customEaseInOut = Easing.bezier(0.14, 0.01, 0.41, 0.99)
export const DURATION_IN_MS = 240
